'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var baseStyle = {
  w: '100%',
  mx: 'auto',
  maxW: {
    sm: 'container.sm',
    md: 'container.md',
    lg: 'container.lg',
    xl: 'container.xl'
  },
  px: 10
};
var Container = {
  baseStyle: baseStyle
};
exports["default"] = Container;